"use client";

import { useRef, useState } from "react";
import Image from "next/image";
import { ChevronLeft, ChevronRight } from "lucide-react";
import EquipmentDialog, { EquipmentItem } from "../opremi-teretanu/EquipmentDialog";

const EQUIPMENT: EquipmentItem[] = [
  {
    id: "1",
    name: "Nautilus Pullover",
    tags: ["Leđa"],
    category: "Sprave",
    image: "/img/equipment/Nautilus-Inspiration-Pull-Over.webp",
    description:
      "Klasična sprava za izolirano jačanje širokog leđnog mišića i stabilizatora ramena kroz pokret povlačenja iznad glave. Prepoznatljiva Nautilus krivulja opterećenja prati prirodnu snagu mišića kroz cijeli raspon pokreta.",
  },
  {
    id: "2",
    name: "Iso-Lateral Leg Press",
    tags: ["Noge"],
    category: "Sprave",
    image: "/img/equipment/Iso-Lateral_Leg_Press.webp",
    description:
      "Sprava za potisak nogu s neovisnim pokretom svake strane, što omogućuje ravnomjeran razvoj snage i ispravlja asimetrije. Pogodna za jačanje kvadricepsa, stražnjice i zadnje lože natkoljenice.",
  },
  {
    id: "3",
    name: "Smith Mašina",
    tags: ["Cijelo tijelo"],
    category: "Sprave",
    image: "/img/equipment/smith_machine.webp",
    description:
      "Univerzalna sprava s vođenom okomitom putanjom šipke koja omogućuje sigurno izvođenje čučnjeva, potisaka i drugih osnovnih vježbi bez potrebe za asistencijom. Idealna za početnike i naprednije korisnike.",
  },
  {
    id: "4",
    name: "Stair master",
    tags: ["Noge"],
    category: "Sprave",
    image: "/img/equipment/stairmaster.jfif",
    description:
      "Kardio sprava koja simulira penjanje stubama, izvrsna za jačanje nogu i stražnjice uz visoku potrošnju kalorija. Podesivi intenzitet omogućuje trening prilagođen svim razinama kondicije.",
  },
  {
    id: "5",
    name: "Hammer Hack Squat",
    tags: ["Noge"],
    category: "Sprave",
    image: "/img/equipment/hammer-strength-hack-squat.webp",
    description:
      "Sprava za čučnjeve s nagnutom, vođenom putanjom koja rasterećuje donji dio leđa uz snažnu aktivaciju kvadricepsa. Sigurnosni osloni omogućuju rad s velikim opterećenjima bez asistencije.",
  },
  {
    id: "6",
    name: "Hammer Incline Chest Press",
    tags: ["Gronji dio prsa"],
    category: "Sprave",
    image: "/img/equipment/hammer-strength-incline-press.webp",
    description:
      "Iso-lateralna sprava za potisak pod kutom namijenjena razvoju gornjeg dijela prsnih mišića i prednjih ramena. Neovisan pokret svake ruke poboljšava simetriju i kontrolu tijekom vježbe.",
  },
  {
    id: "7",
    name: "Hammer Chest Press",
    tags: ["Srednji dio prsa"],
    category: "Sprave",
    image: "/img/equipment/Hammer_Strength_Chest_press.webp",
    description:
      "Iso-lateralna sprava za razvoj prsnih mišića koja omogućuje neovisan pokret svake ruke, čime se poboljšava simetrija i aktivacija mišića. Idealna za progresivno opterećenje kroz sigurnu, kontroliranu putanju pokreta.",
  },
  {
    id: "8",
    name: "Hammer Wide Chest Press",
    tags: ["Vanjski dio prsa"],
    category: "Sprave",
    image: "/img/equipment/hammer-strength-iso-lateral-wide-chest.webp",
    description:
      "Sprava sa širim hvatom namijenjena naglašenoj aktivaciji vanjskog dijela prsnih mišića. Iso-lateralni dizajn omogućuje prirodniju putanju pokreta i bolju kontrolu opterećenja.",
  },
  {
    id: "9",
    name: "Hammer Iso-Lateral Row",
    tags: ["Leđa"],
    category: "Sprave",
    image: "/img/equipment/hammer-strength-plate-loaded-iso-later-rowing-machine.webp",
    description:
      "Sprava za veslanje s neovisnim pokretom svake ruke, namijenjena jačanju širine i debljine leđnih mišića. Opterećenje pločicama omogućuje postupno povećanje intenziteta treninga.",
  },
  {
    id: "10",
    name: "Booty Builder / Back Extension ",
    tags: ["Gluteus", "Donja leđa"],
    category: "Sprave",
    image: "/img/equipment/BB_Backextension.webp",
    description:
      "Sprava specijalizirana za jačanje gluteusa kroz pokret ekstenzije kuka, uz mogućnost izvođenja i ekstenzije leđa. Podesivo opterećenje i udoban jastuk omogućuju siguran trening za sve razine iskustva.",
  },
  {
    id: "11",
    name: "Technogym Iso-Lateral High Row",
    tags: ["Leđa"],
    category: "Sprave",
    image: "/img/equipment/Iso-Lat-High-Row.webp",
    description:
      "Sprava za povlačenje iz visokog položaja koja cilja gornji dio leđa i stražnje ramene mišiće. Neovisan pokret svake ruke osigurava ravnomjeran razvoj snage s obje strane tijela.",
  },
  {
    id: "12",
    name: "Hip Thrust (Smith Machine)",
    tags: ["Gluteus"],
    category: "Sprave",
    image: "/img/equipment/hip-thrust-machine-with-smith.webp",
    description:
      "Prilagodba Smith mašine namijenjena izvođenju hip thrust pokreta uz vođenu, sigurnu putanju šipke. Izvrsna za ciljano jačanje gluteusa uz mogućnost progresivnog povećanja opterećenja.",
  },
  {
    id: "13",
    name: "Hammer Plate Load Shoulder Press ISO",
    tags: ["Ramena"],
    category: "Sprave",
    image: "/img/equipment/hammer-strength-plate-loaded-iso-lateral-shoulder-press.webp",
    description:
      "Iso-lateralna sprava za potisak iznad glave namijenjena jačanju ramena uz kontroliranu, sigurnu putanju pokreta. Neovisan rad svake ruke pomaže u ispravljanju asimetrija u snazi.",
  },
  {
    id: "14",
    name: "PULL/PUSH saonice",
    tags: ["Cijelo tijelo", "Kardio"],
    category: "Sprave",
    image: "/img/equipment/Prowler-Sled-Push-Pull-per-Allen.webp",
    description:
      "Saonice za guranje i povlačenje namijenjene funkcionalnom treningu snage i kondicije cijelog tijela. Svestran alat za razvoj eksplozivnosti, izdržljivosti i snage nogu bez opterećenja zglobova udarcima.",
  },
];

const CARD_WIDTH = 280;
const SCROLL_AMOUNT = CARD_WIDTH + 16; // card width + gap

export default function HomeEquipmentSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [selectedItem, setSelectedItem] = useState<EquipmentItem | null>(null);

  function scrollLeft() {
    scrollRef.current?.scrollBy({ left: -SCROLL_AMOUNT, behavior: "smooth" });
  }

  function scrollRight() {
    scrollRef.current?.scrollBy({ left: SCROLL_AMOUNT, behavior: "smooth" });
  }

  return (
    <>
    <section className="mx-auto max-w-6xl px-6 py-12 sm:px-8 lg:px-10">
      {/* Header */}
      <div className="mb-6 flex items-center justify-between">
        <h2 className="text-3xl font-bold tracking-tight text-[#18181b] sm:text-4xl">
          Upoznajte naše sprave
        </h2>
        <div className="flex items-center gap-2">
          <button
            onClick={scrollLeft}
            aria-label="Prethodna sprava"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-[#E4E4E7] bg-white text-[#18181b] transition-colors hover:bg-[#F9FAFB]"
          >
            <ChevronLeft className="h-4 w-4" />
          </button>
          <button
            onClick={scrollRight}
            aria-label="Sljedeća sprava"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-[#E4E4E7] bg-white text-[#18181b] transition-colors hover:bg-[#F9FAFB]"
          >
            <ChevronRight className="h-4 w-4" />
          </button>
        </div>
      </div>

      {/* Carousel */}
      <div
        ref={scrollRef}
        className="flex gap-4 overflow-x-auto pb-2"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        {EQUIPMENT.map((item) => (
          <button
            key={item.id}
            onClick={() => setSelectedItem(item)}
            className="group flex flex-shrink-0 flex-col overflow-hidden rounded-2xl border border-[#E4E4E7] bg-white text-left transition-shadow hover:shadow-md"
            style={{ width: CARD_WIDTH }}
          >
            {/* Image area — white background */}
            <div className="relative flex h-52 w-full items-center justify-center bg-white p-4">
              <Image
                src={item.image}
                alt={item.name}
                fill
                className="object-contain p-4 transition-transform duration-300 group-hover:scale-105"
              />
            </div>

            {/* Content area — light gray */}
            <div className="flex flex-1 flex-col gap-2 bg-[#F9FAFB] px-4 py-3">
              <p className="text-base font-bold text-[#18181b]">{item.name}</p>
              <div className="flex flex-wrap gap-1.5">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full border border-[#E4E4E7] bg-white px-3 py-0.5 text-xs font-medium text-[#18181b]"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </button>
        ))}
      </div>
    </section>

    <EquipmentDialog item={selectedItem} onClose={() => setSelectedItem(null)} showCta={false} />
    </>
  );
}
